







































































import Vue from "vue";
import Page from "@/components/Page.vue";

import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";

import InterfaceViewToolbar from "../components/InterfaceViewToolbar.vue";
import SyncEntityList from "../components/SyncEntityList.vue";
import VerkInvoiceSyncList from "../components/verkViews/VerkInvoiceSyncList.vue";
import store, { InterfaceStore } from "../services/InterfaceStore";
import { IfaceType } from "../models/IfaceType";
import { t } from "@/plugins/i18n";


interface Data {
  store: InterfaceStore;
  IfaceType: typeof IfaceType;
}

interface Methods {
  getUrl(onlyErrors: boolean): string;
  getColumns(onlyErrors: boolean): ApiSearchColumn[];
}

interface Computed {
  syncListTitle: string;
  syncErrorListTitle: string;
  /** API search URL a hibás szinkron tételekhez (típus + interfész alapján) */
  errorListUrl: string;
  /** API search URL a (nem hibás) szinkron tételekhez */
  syncListUrl: string;
  /** Oszlopok a hibás szinkron tételekhez (típus alapján) */
  errorListColumns: ApiSearchColumn[];
  /** Oszlopok a (nem hibás) szinkron tételekhez (típus alapján) */
  syncListColumns: ApiSearchColumn[];
  /** Toolbarból érkező globális szűrő — apiSearchExtraFilter prop tartalma */
  syncListExtraFilter: object;
  errorListExtraFilter: object;
}

interface Props {
  /**
   * Előzmény mód (Előzmények menüpont) — a listákon csak megtekintő funkciók érhetők el,
   * a toolbaron pedig csak a szűrők.
   */
  historyMode: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Page,
    InterfaceViewToolbar,
    SyncEntityList,
    VerkInvoiceSyncList,
  },

  props: {
    historyMode: { type: Boolean, default: false },
  },

  data() {
    return {
      store,
      IfaceType,
    };
  },

  computed: {
    syncListTitle() {
      let title = t("Interface_SzinkronTetelek");
      switch (this.store.selectedInterfaceType) {
        case IfaceType.Partner:     title = t("Interface_SikeresenAtszinkronizaltPartnerek"); break;
        case IfaceType.Part:        title = t("Interface_SikeresenAtszinkronizaltCikkek"); break;
        case IfaceType.Car:         title = t("Interface_SikeresenAtszinkronizaltGepjarmuvek"); break;
        case IfaceType.InInvoice:   title = t("Interface_SikeresenAtszinkronizaltBejovoSzamlak"); break;
        case IfaceType.OutInvoice:  title = t("Interface_SikeresenAtszinkronizaltKimenoSzamlak");
      }
      return title;
    },
    syncErrorListTitle() {
      let title = t("Interface_HibasSzinkronTetelek");
      switch (this.store.selectedInterfaceType) {
        case IfaceType.Partner:     title = t("Interface_SikertelenulAtszinkronizaltPartnerek"); break;
        case IfaceType.Part:        title = t("Interface_SikertelenulAtszinkronizaltCikkek"); break;
        case IfaceType.Car:         title = t("Interface_SikertelenulAtszinkronizaltGepjarmuvek"); break;
        case IfaceType.InInvoice:   title = t("Interface_SikertelenulAtszinkronizaltBejovoSzamlak"); break;
        case IfaceType.OutInvoice:  title = t("Interface_SikertelenulAtszinkronizaltKimenoSzamlak");
      }
      return title;
    },
    errorListUrl(): string {
      return this.getUrl(true);
    },

    syncListUrl(): string {
      return this.getUrl(false);
    },

    errorListColumns(): any[] {
      return this.getColumns(true);
    },

    syncListColumns(): any[] {
      return this.getColumns(false);
    },

    /** Sikeres listára érvényes globális szűrő (a 3 nem-hiba checkbox alapján). */
    syncListExtraFilter(): object {
      const selectedStatuses: number[] = [];
      if (this.store.statusInProgressOn) selectedStatuses.push(2);
      if (this.store.statusDoneOn) selectedStatuses.push(3);
      // A Verk köztes tábláin az 5 = API-hiba (a hibás kártyán van), nem Kihagyva — ott a checkbox hatástalan
      if (this.store.statusSkipOn && !this.store.isVerkOutInvoice) selectedStatuses.push(5);
      return {
        globalSearch: this.store.globalSearchText,
        fromDate: this.store.fromDate,
        toDate: this.store.toDate,
        selectedStatuses,
      };
    },

    /** Hibás listára érvényes globális szűrő (státusz nélkül — ott csak Error van). */
    errorListExtraFilter(): object {
      return {
        globalSearch: this.store.globalSearchText,
        fromDate: this.store.fromDate,
        toDate: this.store.toDate,
        selectedStatuses: null,
      };
    },
  },

  methods: {
    getColumns(onlyErrors) {
      const errorStatusId = 4;

      const commandCol = {
        field: "selected",
        title: "",
        cell: "command",
        filterable: false,
        sortable: false,
        checkBox: true,
      };

      const statusCol = {
        field: "syncStatusName",
        title: t("Statusz"),
        width: 140,
        cell: "syncStatusName",
        multiselect: true,
        multiselectField: "selectedSyncStatuses",
        multiselectOptions: this.store.syncStatuses
          .filter((s) => s.id !== errorStatusId)
          .map((s) => ({ text: s.name, value: s.id })),
        visible: !onlyErrors,
      };

      switch (this.store.selectedInterfaceType) {
        case IfaceType.Partner: return [
          { ...commandCol, width: 165 },
          { field: "extCode", title: t("Interface_KulsoAzonosito"), width: 100, cell: "disabledText" },
          { field: "partner", title: t("BelsoAzonosito"), width: 100, type: ColumnType.Right, cell: "disabledText" },
          { field: "name", title: t("Nev"), cell: "name" },
          { field: "taxaccount", title: t("Adoszam"), width: 110, cell: "editableText" },
          { field: "euTaxaccount", title: t("Interface_EUAdoszam"), width: 110, cell: "editableText" },
          { field: "countryCode", title: t("Orszag"), width: 60, cell: "editableText" },
          { field: "postcode", title: t("Iranyitoszam"), width: 90, type: ColumnType.Right, cell: "editableText" },
          { field: "city", title: t("Varos"), width: 130, cell: "editableText" },
          { field: "address", title: t("Cim"), cell: "editableText" },
          { field: "syncRemark", title: t("Megjegyzes"), width: 200, cell: "editableText" },
          { field: "errorText", title: t("Hibauzenet"), width: 220, cell: "disabledText", fieldClass: "error-text-col", visible: onlyErrors },
          statusCol,
          { field: "updUserName", title: t("UtoljaraModositotta"), width: 150, cell: "disabledText" },
          { field: "updDateTime", title: t("Interface_UtolsoModIdeje"), width: 150, range: true, cell: "updDateTime" },
        ];
        case IfaceType.Car: return [
          // Gépjárműhöz csak lista van (nincs szerkesztő), ezért minden cella csak olvasható.
          // Parancs-oszlop: kijelölő + nagyító + előzmény gomb (a partnernél 4 gomb 165-ben fér el).
          { ...commandCol, width: 130 },
          { field: "extCode", title: "Külső azonosító", width: 150, cell: "disabledText" },
          { field: "car", title: "Belső azonosító", width: 100, type: ColumnType.Right, cell: "disabledText" },
          { field: "bodyNo", title: "Alvázszám", width: 170, cell: "disabledText" },
          { field: "regNum", title: "Rendszám", width: 100, cell: "disabledText" },
          { field: "engineNo", title: "Motorszám", width: 120, cell: "disabledText" },
          { field: "brand", title: "Márka", width: 100, cell: "disabledText" },
          { field: "modell", title: "Modell", cell: "disabledText" },
          { field: "color", title: "Szín", width: 100, cell: "disabledText" },
          { field: "owner", title: "Tulajdonos kód", width: 110, cell: "disabledText" },
          { field: "syncRemark", title: "Megjegyzés", width: 200, cell: "disabledText" },
          { field: "errorText", title: "Hibaüzenet", width: 220, cell: "disabledText", fieldClass: "error-text-col", visible: onlyErrors },
          statusCol,
          { field: "updUserName", title: "Utoljára módosította", width: 150, cell: "disabledText" },
          { field: "updDateTime", title: "Utolsó szinkron ideje", width: 110, filterable: false, cell: "updDateTime" },
        ];
        case IfaceType.InInvoice:
        case IfaceType.OutInvoice: {
          return [
            { ...commandCol, width: 205 },
            { field: "extCode", title: t("Interface_KulsoAzonosito"), width: 120, cell: "disabledText" },
            { field: "invNo", title: t("Szamlaszam"), width: 150, cell: "invNo" },
            { field: "partnerCode", title: t("Partner"), width: 230, cell: "invoicePartner" },
            { field: "invDate", title: t("SzamlaDatuma"), width: 150, cell: "editableDate", range: true },
            { field: "shipDate", title: t("TeljDatuma"), width: 150, cell: "editableDate", range: true },
            { field: "pterm", title: t("Interface_FizetesiHatIdo"), width: 150, cell: "editableDate", range: true },
            { field: "currNetto", title: t("Interface_NettoDev"), width: 110, type: ColumnType.Money, cell: "calculatedMoney", filterable: false },
            { field: "currVat", title: t("Interface_AfaDev"), width: 110, type: ColumnType.Money, cell: "calculatedMoney", filterable: false },
            { field: "currTotal", title: t("Interface_BruttoDev"), width: 110, type: ColumnType.Money, cell: "editableMoney", filterable: false },
            { field: "invCurrency", title: t("Penznem"), width: 60, cell: "disabledText" },
            { field: "exchangeRate", title: t("Arfolyam"), width: 60, type: ColumnType.Money, cell: "disabledText" },
            { field: "payMode", title: t("FizetesiMod"), width: 170, cell: "payMode" },
            { field: "syncRemark", title: t("Megjegyzes"), width: 150, cell: "editableText" },
            { field: "errorText", title: t("Hibauzenet"), width: 200, cell: "disabledText", fieldClass: "error-text-col", visible: onlyErrors },
            statusCol,
            { field: "updUserName", title: t("UtoljaraModositotta"), width: 150, cell: "disabledText" },
            { field: "updDateTime", title: t("Interface_UtolsoModIdeje"), width: 150, range: true, cell: "updDateTime" },
          ];
        }
        default:
          return [commandCol];
      }
    },

    getUrl(onlyErrors) {
      if (this.store.selectedInterface <= 1 || this.store.selectedInterfaceType <= 1)
        return "";

      // Verk + kimenő számla: nem a közös köztes tábla, hanem a VerkInvoiceSyncList saját végpontja
      if (this.store.isVerkOutInvoice)
        return "";

      switch (this.store.selectedInterfaceType) {
        case IfaceType.Partner:    return `iface-sync-partner/search/${this.store.selectedInterface}/${onlyErrors}`;
        case IfaceType.Car:        return `iface-sync-car/search/${this.store.selectedInterface}/${onlyErrors}`;
        case IfaceType.InInvoice:  return `iface-sync-invoice-head/search/${this.store.selectedInterface}/IN/${onlyErrors}`;
        case IfaceType.OutInvoice: return `iface-sync-invoice-head/search/${this.store.selectedInterface}/OUT/${onlyErrors}`;
        default: return "";
      }
    },
  },
});
